import { rem } from 'polished'
import styled from 'styled-components'
import tw from 'twin.macro'

export const Root = styled.nav`
  ${tw`block my-2 mx-0 p-0`};
  font-size: ${rem(12)};
  color: var(--color-blue-grey);
`

export const Crumbs = styled.ol``

export const Crumb = styled.li`
  ${tw`list-none inline`}

  & + &::before {
    content: ' > ';
  }
`
